module.exports = __webpack_public_path__ + "src/img/zalando/img-zalando-websites-2.1cd19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-zalando-websites-2.jpg
// module id = 129
// module chunks = 0